import { RadioProps, Radio } from "@material-ui/core";
import React from "react";

export function StyledRadioButton(
  props: RadioProps & { checkedIcon: JSX.Element } & { icon: JSX.Element }
) {
  return (
    <Radio
      disableRipple={true}
      color="default"
      checkedIcon={props.checkedIcon}
      icon={props.icon}
      {...props}
    />
  );
}
